import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import { RoleService } from 'src/app/services/role/role.service';
import { Role } from 'src/app/model/role/role.model';
import { Roleassign } from 'src/app/model/role/roleassign.model';
import { NgForm } from '@angular/forms';
import { RoleguardServiceGuard } from 'src/app/auth/roleguard-service.guard';
import { Userobjects } from 'src/app/model/role/userobjects.model';
import { stringify } from 'querystring';
import { Roledata } from 'src/app/model/role/roledata.model';
//import swal from 'sweetalert';

//import { Userobjects } from 'src/app/model/pvr/userobjects.model';
@Component({
  selector: 'app-editrole',
  templateUrl: './editrole.component.html',
  styleUrls: ['./editrole.component.css']
})
// start from here
export class EditroleComponent implements OnInit {
  data: Userobjects[];
  roleData:Roledata;
  dataAny:any;

 // roleData
  roles: Roleassign[];
  role: Roleassign;
  roleName: string;
  roleDescription: string;
  roleId: number;
  // test: boolean = true;


  //data1:Role;

  //constructor(private tendringservice:TenderingService) { }
  constructor(private roleservice: RoleService, private route: ActivatedRoute,private router:Router) {
    debugger;
    //this.roleId = this.route.snapshot.params.roleid;
    this.roleId = this.route.snapshot.params.id;

  }

  ngOnInit() {

    //this.role = new Roleassign();
    this.getViewUserRole();
    this.getRoleHeading();
    this.roleData=new Roledata();

  }
  getRoleHeading()
  {
    this.roleservice.getRoleHeading(this.roleId).subscribe(
      (data: any) => {
        debugger;

        this.dataAny = data;
        this.roleData=this.dataAny
          console.log(data);
      })

  }
  getViewUserRole() {

    debugger;
    this.roleservice.getViewUserRole(this.roleId).subscribe(
      (data: any) => {
        debugger;

        this.data = data;
          console.log(data);
      })
  }



  OnClick(id: number) {
    //debugger;
    //alert(id);
    var element = <HTMLInputElement>document.getElementById("update" + id);

    var isChecked = element.checked;
    if (isChecked) {
      var element = <HTMLInputElement>document.getElementById("read" + id);
      element.checked = true;
      this.data[id].read = true;
    }
  }
  SubmitForm(form: NgForm) {
    debugger;
    console.log(form.value);
    console.log(this.data);
    this.roleData.id = this.roleId;
    this.roleservice.updateroleheading(this.roleData).subscribe(
      data => {
        if (data == true) {
          this.roleservice.updaterole(this.data).subscribe(
            data => {
              if (data == true) {
                alert("updated");
                this.router.navigate(['/userrole']);
                console.log(data);
              }
              else {
                alert("An error occured");
              }

            }

          )

        }
        else {
        }

      }

    )


  }

  cancel()
  {
    this.router.navigate(['/userrole']);
  }

}



